import { bl_fi_deposit_requisition_hdr_entity_link_RowClass } from '../../dbschema/bl_fi_deposit_requisition_hdr_entity_link.model';
import { BaseContainerModel } from '../base-container.model';

export class DepositRequisitionEntityLinkContainerModel extends BaseContainerModel {
    bl_fi_deposit_requisition_hdr_entity_link: bl_fi_deposit_requisition_hdr_entity_link_RowClass = new bl_fi_deposit_requisition_hdr_entity_link_RowClass();
}